<template>
  <el-form-item
    :prop="`filters.balance_crosses_threshold.value`"
    label="Balance threshold"
  >
    <el-input-number
      v-model="form.balance_crosses_threshold.value"
      :controls="false"
      :step-strictly="true"
      type="number"
    />
  </el-form-item>
</template>

<script lang="ts">
import { computed, ref } from 'vue'

export default {
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, context) {
    const form = computed({
      get: () => {
        return props.modelValue
      },
      set: (val) => {
        context.emit('update:modelValue', val)
      }
    })

    return {
      form
    }
  }
}
</script>

<style lang="scss" scoped>
.el-input-group__prepend {
  .el-select {
    width: 150px;
  }
}

.el-input {
  &.hide-value {
    :deep(.el-select__wrapper) {
      box-shadow: 0 0 0 1px var(--el-border-color) inset !important;
    }
    :deep(.el-input__wrapper) {
      visibility: hidden;
    }
  }
}
</style>
